import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';

export const CheckHealt = () => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.get(GetBackendUrlForGlobalFunctions() + `healt-check`, {
    headers,
  });
};
